// extracted by mini-css-extract-plugin
export default {"wrapper":"Visits_wrapper__wIWeB","filter":"Visits_filter__R3IuH"};